import { useState, useEffect } from "react";
import apis from '../api';

const useParamsCIR = () => {
    const [params, setParams] = useState([]);
    const headers = {
        authorization: localStorage.getItem('token')
    }
    let payload = {
        CLIENT: localStorage.getItem('client'),
        ENTITY: localStorage.getItem('entity'),
        OPTION: "2"
    }
    useEffect(() => {
        const getParams = async () => {
            let parametros = [];
            let lista = [];
            await apis.postReportCIR(payload, headers).then(res => {
                parametros = res.data["SHEETS"][0]
                //console.log(parametros);
            })
            parametros["DETAIL"].forEach((row, i) => {
                lista.push({
                    VALUE: "", LABEL: row.NAME, OPTIONS: row.DETAIL, TAG: row.LABEL,
                    SHEET: parametros.NAME, SHEET_POSITION: i, POSITION: row.POSITION, TYPE: row.TYPE_NATIVE, REQUIRED: row.REQUIRED
                })
            })
            setParams(lista)
            console.log(lista)
        }
        getParams()
    }, []);

    return [params];
};

export default useParamsCIR;